import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectorRef, ViewChild } from '@angular/core';

@Component({
    selector: 'adminapp-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent implements OnInit {
    constructor(private changeDetectorRef: ChangeDetectorRef) { }
    @Input() selectFile = '';
    @Input() name = '';
    @Input() preChange: Function;
    @Input () disabled: boolean;
    @Output() file = new EventEmitter<File>();

    @ViewChild('file') fileUploadInput;

    ngOnInit() {
    }

    fileEvent($event) {
        const file = $event.target.files[0];

        if ($event.target.files[0].type === 'application/x-zip-compressed') {
          this.selectFile = file.name;
        this.file.emit(file);
        } else {
          this.handleFailure('You can upload only ZIP files!');
        }
    }
    onclick($event) {
        if (this.preChange && !this.preChange()) { $event.preventDefault(); }
        if (this.fileUploadInput) {
          this.fileUploadInput.nativeElement.value = '';
        }
    }

    handleFailure(error) {

      const criticalUploadZip: any = document.querySelector('#criticalUploadZip');

      criticalUploadZip.text = error;
      criticalUploadZip.open();

      this.changeDetectorRef.detectChanges();
    }
}
